import React from "react";

function VodaFoneCollection() {
  return (
    <section className="inner-work inner-bx top-sb">
      <div className="container">
        <h2>Vodafone Collection</h2>
        <h4>Vodafone Collection Process</h4>

        <ul>

          <li className="bes-list">
            <figure>
              <img src="/images/image nitish/Matrix/Vodafone/1.png" alt="Vodafone Home" />
            </figure>

            <aside>
              <h4>Vodafone Collection Home</h4>

              <img src="/images/image nitish/Matrix/Vodafone/2.png" alt="Vodafone screen" />
              <img src="/images/image nitish/Matrix/Vodafone/3.png" alt="Vodafone screen" />
            </aside>
          </li>


          <li className="bes-list">

            <aside>
              <h4>Vodafone Collection Screen</h4>

              <img src="/images/image nitish/Matrix/Vodafone/4.png" alt="Vodafone screen" />
              <img src="/images/vodafone/5.png" alt="Vodafone screen" />
            </aside>

            <figure>
              <img src="/images/image nitish/Matrix/Vodafone/6.png" alt="Vodafone screen" />
            </figure>

          </li>


          <li className="bes-list">

            <figure>
              <img src="/images/image nitish/Matrix/Vodafone/2.png" alt="Vodafone report" />
            </figure>

            <aside>
              <h4>Vodafone Collection Reports</h4>

              <img src="/images/image nitish/Matrix/Vodafone/7.png" alt="Vodafone report" />
              <img src="/images/image nitish/Matrix/Vodafone/1.png" alt="Vodafone report" />
            </aside>

          </li>

        </ul>
      </div>
    </section>
  );
}

export default VodaFoneCollection;